import { render, staticRenderFns } from "./typelist.vue?vue&type=template&id=64be4d9b&"
import script from "./typelist.vue?vue&type=script&lang=js&"
export * from "./typelist.vue?vue&type=script&lang=js&"
import style0 from "./typelist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports